import React, { useState, useRef, useEffect } from 'react';

const CustomSelect = ({ options, value, onChange, placeholder, label, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    const selectedOption = options.find(option => option.value === value);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleOptionClick = (e, optionValue) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(optionValue);
        setIsOpen(false);
    };

    return (
        <div className={`relative ${className || ''}`} ref={selectRef}>
            {label && (
                <label className="block text-xs font-bold uppercase tracking-wider text-gray-400 mb-2">
                    {label}
                </label>
            )}
            <button
                type="button"
                className={`w-full h-12 px-4 rounded-xl bg-[#1e293b] border border-white/10 text-white font-bold flex items-center justify-between transition-all duration-200 ${isOpen ? 'border-amber-500/50 shadow-[0_0_15px_rgba(245,158,11,0.1)]' : 'hover:bg-white/5'}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={!selectedOption ? 'text-gray-400' : ''}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <svg
                    className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180 text-amber-400' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute z-50 w-full mt-2 rounded-xl bg-[#0f172a] border border-white/10 shadow-2xl max-h-60 overflow-y-auto no-scrollbar ring-1 ring-black/5">
                    <div className="p-1">
                        {options.map((option) => (
                            <div
                                key={option.value}
                                className={`px-4 py-3 rounded-lg cursor-pointer text-sm font-bold transition-colors ${option.value === value
                                    ? 'bg-amber-500/20 text-amber-400'
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white'
                                    }`}
                                onClick={(e) => handleOptionClick(e, option.value)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomSelect;